export default __webpack_public_path__ + "static/languageRecognition-4897e4fdcb79353941d5cf129d54576a.png";